"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deprecate;
function deprecate() {
  for (var _len = arguments.length, consoleArgs = Array(_len), _key = 0; _key < _len; _key++) {
    consoleArgs[_key] = arguments[_key];
  }

  return function (alternateFunc) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      // eslint-disable-next-line no-console
      console.warn.apply(console, consoleArgs);
      return alternateFunc.apply(null, args);
    };
  };
}
module.exports = exports["default"];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL21vZHVsZXMvdXRpbHMvZGVwcmVjYXRlLmpzIl0sIm5hbWVzIjpbImRlcHJlY2F0ZSIsImNvbnNvbGVBcmdzIiwiYWx0ZXJuYXRlRnVuYyIsImFyZ3MiLCJjb25zb2xlIiwid2FybiIsImFwcGx5Il0sIm1hcHBpbmdzIjoiOzs7OztrQkFBd0JBLFM7QUFBVCxTQUFTQSxTQUFULEdBQW9DO0FBQUEsb0NBQWJDLFdBQWE7QUFBYkEsZUFBYTtBQUFBOztBQUNqRCxTQUFPLFVBQUNDLGFBQUQ7QUFBQSxXQUFtQixZQUFhO0FBQUEseUNBQVRDLElBQVM7QUFBVEEsWUFBUztBQUFBOztBQUNyQztBQUNBQyxjQUFRQyxJQUFSLENBQWFDLEtBQWIsQ0FBbUJGLE9BQW5CLEVBQTRCSCxXQUE1QjtBQUNBLGFBQU9DLGNBQWNJLEtBQWQsQ0FBb0IsSUFBcEIsRUFBMEJILElBQTFCLENBQVA7QUFDRCxLQUpNO0FBQUEsR0FBUDtBQUtEIiwiZmlsZSI6ImRlcHJlY2F0ZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGRlcHJlY2F0ZSAoLi4uY29uc29sZUFyZ3MpIHtcbiAgcmV0dXJuIChhbHRlcm5hdGVGdW5jKSA9PiAoLi4uYXJncykgPT4ge1xuICAgIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBuby1jb25zb2xlXG4gICAgY29uc29sZS53YXJuLmFwcGx5KGNvbnNvbGUsIGNvbnNvbGVBcmdzKVxuICAgIHJldHVybiBhbHRlcm5hdGVGdW5jLmFwcGx5KG51bGwsIGFyZ3MpXG4gIH1cbn1cbiJdfQ==